import axios from "axios";
import ENDPOINT from "../../context/EndPoint";

// Save a new reusable template (id=0) or update an existing one (id>0).
const SaveCertificateTemplate = async ({ payload }) => {
  const formData = new FormData();
  formData.append("id", payload.id || 0);
  formData.append("name", payload.name || "Untitled template");
  formData.append("type", payload.type || "training");
  formData.append("svg", payload.svg || "");
  formData.append("width", payload.width || 1000);
  formData.append("height", payload.height || 700);
  if (payload.session) formData.append("session", payload.session);

  const res = await axios.post(ENDPOINT + "admin-save-certificate-template.php", formData, {
    headers: { "content-type": "multipart/form-data" },
  });
  return res ? res.data : null;
};

export default SaveCertificateTemplate;
